import { motion } from 'motion/react';
import styles from './Player.module.css';
import { parsePlayer } from '../../helpers/titreHelper';
import { delay } from 'motion';

export const Player = ({ player }) => {
  if (!player) {
    return null;
  }

  const { varImgUrl, comment } = player;
  const { name, number } = parsePlayer(comment);

  return (
    <div className={styles.wrapper}>
      <motion.div
        initial={{ x: '-100%' }}
        animate={{
          x: 0,
          transition: { delay: 0.33, duration: 0.66, ease: 'easeOut' },
        }}
        exit={{ x: '-100%', transition: { duration: 0.33, ease: 'easeOut' } }}
        className={styles.imgBlock}
      >
        {varImgUrl && (
          <img src={varImgUrl} alt="player" className={styles.playerImg} />
        )}
      </motion.div>

      <div className={styles.textsBlock}>
        {number && (
          <motion.div
            initial={{ maskSize: '0% 100%' }}
            animate={{
              maskSize: '350% 100%',
              transition: { duration: 0.66, ease: 'easeOut' },
            }}
            exit={{
              maskSize: '0% 100%',
              transition: { duration: 0.37, ease: 'easeOut' },
            }}
            className={`${styles.playerNumber} ${styles.playerMask}`}
          >
            №{number}
          </motion.div>
        )}
        {name && (
          <motion.div
            initial={{ maskSize: '0% 100%' }}
            animate={{
              maskSize: '350% 100%',
              transition: { delay: 0.33, duration: 0.66, ease: 'easeOut' },
            }}
            exit={{
              maskSize: '0% 100%',
              transition: { delay: 0.07, duration: 0.37, ease: 'easeOut' },
            }}
            className={`${styles.playerName} ${styles.playerMask}`}
          >
            {name}
          </motion.div>
        )}

        <div className={styles.words}>
          <motion.div
            className={styles.word1}
            initial={{ x: '200%' }}
            animate={{
              x: 0,
              transition: { delay: 0.5, duration: 0.5, ease: 'easeOut' },
            }}
            exit={{
              x: '200%',
              transition: { delay: 0.07, duration: 0.43, ease: 'easeOut' },
            }}
          >
            сделал
          </motion.div>
          <motion.div
            className={styles.word2}
            initial={{ x: '150%' }}
            animate={{
              x: 0,
              transition: { delay: 0.77, duration: 0.4, ease: 'easeOut' },
            }}
            exit={{
              x: '150%',
              transition: { delay: 0.2, duration: 0.43, ease: 'easeOut' },
            }}
          >
            разницу
          </motion.div>
        </div>
      </div>
    </div>
  );
};
